import { CLEAR_DATA, GET_USER_DATA, SET_USER_DATA } from "../constans";

export interface AuthState {
  id: string | null,
  email: string | null,
  telegramId: number | null,
  stakingKey: string | null,
  p2pKey: string | null,
}

interface SetUserDataAction {
  type: typeof SET_USER_DATA;
  payload: AuthState;
}

interface GetUserDataAction {
  type: typeof GET_USER_DATA;
}

interface ClearDataAction {
  type: typeof CLEAR_DATA;
}

type AuthActionTypes = SetUserDataAction | GetUserDataAction | ClearDataAction;

const initialState: AuthState = {
  id: null,
  email: null,
  telegramId: null,
  stakingKey: null,
  p2pKey: null
};

export const userDataReduser = (state = initialState, action: AuthActionTypes): AuthState => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        id: action.payload.id,
        email: action.payload.email,
        telegramId: action.payload.telegramId,
        stakingKey: action.payload.stakingKey,
        p2pKey: action.payload.p2pKey
      };

    case GET_USER_DATA:
      return state

    case CLEAR_DATA:
      return {
        ...state,
        id: null,
        email: null,
        telegramId: null,
        stakingKey: null,
        p2pKey: null
      }

    default:
      return state;
  }
}

export const SetUserData = (userData: AuthState) => ({
  type: SET_USER_DATA,
  payload: userData
});

export const GetUserData = () => ({
  type: GET_USER_DATA
});

export const clearData = () => ({
  type: CLEAR_DATA
})
